import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import ElementUI from 'element-ui'
import axios from 'axios'
import './libs/common/validator'
// import VueCookies from 'vue-cookies'
import '../theme/index.css'
import './assets/styles/reset.less'
import './assets/styles/common.less'
import './assets/styles/form.less'
import md5 from 'js-md5'
Vue.prototype.$md5 = md5
// import Vconsole from 'vconsole'
// Vue.use(MintUI)
Vue.use(ElementUI)
// Vue.use(VueCookies)
Vue.config.productionTip = false;
Vue.prototype.axios = axios
if (process.env.NODE_ENV === 'development') {
  Vue.prototype.auth = '/ac'
  Vue.prototype.user = '/uc'
  Vue.prototype.order = '/od'
  Vue.prototype.sp = '/prd'
  Vue.prototype.web = '/we'
  Vue.prototype.sb = '/sb'
  // const vconsole = new Vconsole()
} else {
  Vue.prototype.auth = '/auth'
  Vue.prototype.user = '/user'
  Vue.prototype.order = '/order'
  Vue.prototype.sp = '/product'
  Vue.prototype.web = '/web'
}

router.afterEach((to, from, next) => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
      let hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?cab042c1d1c9f6f8d224c9f58e62e285';
      hm.id = 'baidu_tj'
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
